module.exports = __webpack_public_path__ + "static/media/class.a84b7185.jpg";